<div class="root-container">
  <i (click)="collapsed.set(!collapsed())" class="bi bi-list menu"></i>
  <div class="display" [ngClass]="{ show: collapsed() }">
    <div class="content">
      <div class="d-flex justify-content-between">
        <a routerLink="/" class="my-auto"
          ><img src="assets/images/common/company_logo.png"
        /></a>
        <i (click)="collapsed.set(!collapsed())" class="bi bi-list menu"></i>
      </div>

      <div class="links">
        @if(isLogged()) { @for (link of links(); track $index) {
        <a
          [routerLink]="`/${link.url}`"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="collapsed.set(false)"
          class="nav-link"
        >
          {{ link.name }}
        </a>
        }
        <a
          routerLink="/browse/cart"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="collapsed.set(false)"
          class="nav-link"
          ><span>Cart</span>
          @if(cartLength()) {
          <div class="data-count">
            {{ cartLength() }}
          </div>
          }
        </a>
        } @if(!isLogged()) {
        <a class="auth-link" (click)="login()"
          ><i class="bi bi-box-arrow-in-right"></i><span>Login</span></a
        >
        <a routerLink="/register" class="auth-link"
          ><i class="bi bi-person-plus"></i><span>Sign Up</span></a
        >
        }
      </div>

      @if(isLogged()) {
      <div class="end-links">
        <div class="user" slot="header">
          <i class="bi bi-person-circle"></i>
          <div>
            <h3>{{ username() }}</h3>
            <span>{{ user()?.email }}</span>
          </div>
        </div>
        <button type="button" (click)="logout()">
          <i class="bi bi-box-arrow-right"></i> Logout
        </button>
      </div>
      }
    </div>
  </div>
</div>
